export default __webpack_public_path__ + "static/media/json-icon.57ab6c3c.svg";